import { render, staticRenderFns } from "./customer-qantity-product.vue?vue&type=template&id=3c3a873c"
import script from "./customer-qantity-product.vue?vue&type=script&lang=js"
export * from "./customer-qantity-product.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3a873c')) {
      api.createRecord('3c3a873c', component.options)
    } else {
      api.reload('3c3a873c', component.options)
    }
    module.hot.accept("./customer-qantity-product.vue?vue&type=template&id=3c3a873c", function () {
      api.rerender('3c3a873c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/stat-analyze/customer-analyze/customer-qantity-product.vue"
export default component.exports